/**
 * FASE 20.2 — People Query Adapter
 */

import { supabase }             from "../../supabase";
import { applyPermissionScope } from "../permissionFilters";

const PERSON_FIELDS = "id, name, baptism_status, spiritual_status, district_role, family_id";

/**
 * Member status distribution — baptism + spiritual status counts.
 * Returns compact rows, not individual records.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getMemberStatus(scope) {
  let query = supabase
    .from("people")
    .select(PERSON_FIELDS)
    .order("name", { ascending: true })
    .limit(25);

  // People table uses church_id via families join — scope via family church
  // For permission scope, we apply district_id or church_id on direct column
  if (scope.level === "church" && scope.church_id) {
    // Need to join via families to get church_id — use a view or direct column if available
    // Fall back to district_id scoping if no church column on people
    if (scope.district_id) {
      query = query.eq("district_id", scope.district_id);
    }
  } else if (scope.level === "district" && scope.district_id) {
    query = query.eq("district_id", scope.district_id);
  } else {
    query = query.eq("id", "00000000-0000-0000-0000-000000000000");
  }

  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

/**
 * People who need pastoral followup — no recent visit in 60 days.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getPeopleNeedingFollowup(scope) {
  let query = supabase
    .from("people")
    .select("id, name, baptism_status, spiritual_status, district_role, family_id")
    .order("name", { ascending: true })
    .limit(20);

  if (scope.level === "district" && scope.district_id) {
    query = query.eq("district_id", scope.district_id);
  } else if (scope.level === "church" && scope.district_id) {
    query = query.eq("district_id", scope.district_id);
  } else {
    query = query.eq("id", "00000000-0000-0000-0000-000000000000");
  }

  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}
